import { render, staticRenderFns } from "./MetricsCard.vue?vue&type=template&id=2d2db922"
import script from "./MetricsCard.vue?vue&type=script&lang=js"
export * from "./MetricsCard.vue?vue&type=script&lang=js"
import style0 from "./MetricsCard.vue?vue&type=style&index=0&id=2d2db922&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports